export const translations = {
  nl: {
    intlLocale: "nl-NL",
    ui: {
      "general.loading": "Laden...",
      "time.unknown": "Onbekend",
      "time.just_now": "Zojuist",
      "sensor.unknown_id": "Sensor ID onbekend",
      "sensor.valid_options": "Geldige opties:",
      "sensor.not_specified": "Niet opgegeven",
      "sensor.fallback_label": "Sensor #{{id}}",
      "sensor.label_suffix_healthy": " gezond",
      "sensor.label_suffix_ok": " OK",
      "impact_level.impact": "Met impact",
      "impact_level.non_impact": "Zonder impact",
      "impact_level.informational": "Informatief",
      "impact_level.unknown": "Onbekend",
      "impact_level.invalid": "Ongeldig impactniveau",
      "status.healthy": "Gezond",
      "status.unhealthy": "Ongezond",
      "reset_steering.title": "Reset sturing",
      "reset_steering.idle_label": "Idle reset sturing",
      "reset_steering.force_label": "Force reset sturing",
      "reset_steering.confirm_question": "Weet je het zeker?",
      "reset_steering.confirm": "Bevestig",
      "reset_steering.cancel": "Annuleer",
      "reset_steering.sending": "Bezig...",
      "reset_steering.success": "Reset sturing verstuurd",
      "reset_steering.error": "Reset sturing mislukt",
      "reset_steering.no_capability":
        "Deze lift ondersteunt het resetten van de sturing niet.",
      "reset_steering.no_permission":
        "Dit account heeft geen rechten om de sturing te resetten.",
      "status_messages.title": "Statusmeldingen",
      "status_messages.loading": "Meldingen laden...",
      "status_messages.last_known":
        "Laatste bekende statussen (mogelijk niet meer actueel)",
      "status_messages.none": "Geen actuele statusmeldingen",
      "indicator.no_id": "Geen ID opgegeven",
      "scene.failed_to_load": "3D-scene bestand laden mislukt",
      "data.connection_restored": "Verbinding hersteld",
      "error.compact.no_token": "Geen token",
      "error.compact.invalid_token": "Token ongeldig",
      "error.compact.no_data": "Geen data",
      "error.compact.no_connection": "Geen verbinding",
      "error.compact.data_error": "Data fout",
      "error.compact.generic": "Fout",
      "components.ls_history": "ls-history",
      "components.ls_status_history": "ls-status-history",
      "components.ls_counters": "ls-counters",
    },
    errors: {
      CONSOLE_INFO: "Zie browser console voor meer informatie",
      STORE_UNAVAILABLE: "Data store niet beschikbaar",
      STORE_CREATION_FAILED: "Aanmaken van store mislukt. Zie browser console.",
      SOCKET_CONNECTION_FAILED: "Verbinding met Socket server verbroken",
      SENSECLOUD_CONNECTION_FAILED: "Verbinding met Sensecloud verbroken",
      NO_ACCESS_TOKEN: "Geen access token gevonden",
      INVALID_ACCESS_TOKEN: "Access token is ongeldig",
      HISTORIC_DATA_FAILED: "Ophalen historische gegevens mislukt",
      CONTROLLER_CONNECTION_FAILED: "Verbinding met sturing verbroken",
      BACK_DOOR_CHECK_FAILED: "Ophalen gegevens deur achter mislukt",
    },
    sensorLabels: {
      "10": "Verbinding met Sensecloud gezond",
      "23": "Mobiele signaalsterkte",
      "54": "Energiemeter 3-fase",
      "55": "Energiemeter 1-fase",
      "104": "Bezoek",
      "105": "Beschikbaar",
      "106": "Lift in storing",
      "210": "Verzamel storing",
      "211": "Verzamel melding",
      "212": "Technisch beschikbaar",
      "500": "Bewegingstoestand",
      "501": "Huidige stopplaats (open deuren)",
      "502": "Deur positie voor",
      "503": "Deur positie achter",
      "513": "Statusmeldingen",
      "514": "Laatst gepasseerde stopplaats",
      "515": "Huidige stopplaats",
      "524": "Verbinding met sturing gezond",
      "550": "Na oproep geen reactie",
      "590": "Sturing info",
      "592": "Lift plugin",
    },
    sensorLabelsShort: {
      "10": "Sensecloud OK",
      "23": "Mobiel signaal",
      "54": "Energiemeter 3-fase",
      "55": "Energiemeter 1-fase",
      "104": "Bezoek",
      "105": "Beschikbaar",
      "106": "Lift in storing",
      "210": "Verzamel storing",
      "211": "Verzamel melding",
      "212": "Technisch beschikbaar",
      "500": "Status lift",
      "501": "Huidige stop",
      "502": "Deur voor",
      "503": "Deur achter",
      "513": "Statusmeldingen",
      "514": "Laatst gepasseerd",
      "515": "Huidige stop",
      "524": "Sturing OK",
      "550": "Geen reactie",
      "590": "Sturing info",
      "592": "Lift plugin",
    },
    sensorValues: {
      C: "Dicht",
      D: "Naar beneden",
      I: "Inactief",
      O: "Open",
      U: "Naar boven",
      X: "Vergrendeld",
      "-": "Sluiten",
      "+": "Openen",
      "?": "Fout",
      "¿": "Fout",
    },
  },
  en: {
    intlLocale: "en-US",
    ui: {
      "general.loading": "Loading...",
      "time.unknown": "Unknown",
      "time.just_now": "Just now",
      "sensor.unknown_id": "Unknown sensor ID",
      "sensor.valid_options": "Valid options:",
      "sensor.not_specified": "not specified",
      "sensor.fallback_label": "Sensor #{{id}}",
      "sensor.label_suffix_healthy": " healthy",
      "sensor.label_suffix_ok": " OK",
      "impact_level.impact": "Impact",
      "impact_level.non_impact": "Non-impact",
      "impact_level.informational": "Informational",
      "impact_level.unknown": "Unknown",
      "impact_level.invalid": "Invalid impact level",
      "status.healthy": "Healthy",
      "status.unhealthy": "Unhealthy",
      "reset_steering.title": "Reset steering",
      "reset_steering.idle_label": "Idle reset steering",
      "reset_steering.force_label": "Force reset steering",
      "reset_steering.confirm_question": "Are you sure?",
      "reset_steering.confirm": "Confirm",
      "reset_steering.cancel": "Cancel",
      "reset_steering.sending": "Sending...",
      "reset_steering.success": "Reset steering sent",
      "reset_steering.error": "Reset steering failed",
      "reset_steering.no_capability":
        "This lift does not support resetting the steering.",
      "reset_steering.no_permission":
        "This account does not have permission to reset the steering.",
      "status_messages.title": "Status messages",
      "status_messages.loading": "Loading messages...",
      "status_messages.last_known": "Last known statuses (may be out of date)",
      "status_messages.none": "No current status messages",
      "indicator.no_id": "No ID supplied",
      "scene.failed_to_load": "Failed to load 3D scene file",
      "data.connection_restored": "Connection restored",
      "error.compact.no_token": "No token",
      "error.compact.invalid_token": "Invalid token",
      "error.compact.no_data": "No data",
      "error.compact.no_connection": "No connection",
      "error.compact.data_error": "Data error",
      "error.compact.generic": "Error",
      "components.ls_history": "ls-history",
      "components.ls_status_history": "ls-status-history",
      "components.ls_counters": "ls-counters",
    },
    errors: {
      CONSOLE_INFO: "See browser console for more information",
      STORE_UNAVAILABLE: "Data store not available",
      STORE_CREATION_FAILED: "Failed to create store. See browser console.",
      SOCKET_CONNECTION_FAILED: "Connection to Socket server lost",
      SENSECLOUD_CONNECTION_FAILED: "Connection to Sensecloud lost",
      NO_ACCESS_TOKEN: "No access token found",
      INVALID_ACCESS_TOKEN: "Access token is invalid",
      HISTORIC_DATA_FAILED: "Failed to fetch historical data",
      CONTROLLER_CONNECTION_FAILED: "Connection to controller lost",
      BACK_DOOR_CHECK_FAILED: "Failed to fetch back door data",
    },
    sensorLabels: {
      "10": "Sensecloud connection healthy",
      "23": "Mobile signal strength",
      "54": "Energy meter 3-phase",
      "55": "Energy meter 1-phase",
      "104": "Visit",
      "105": "Available",
      "106": "Elevator in fault",
      "210": "Aggregated fault",
      "211": "Aggregated message",
      "212": "Technically available",
      "500": "Movement state",
      "501": "Current stop (doors open)",
      "502": "Front door position",
      "503": "Rear door position",
      "513": "Status messages",
      "514": "Last passed stop",
      "515": "Current stop",
      "524": "Controller connection healthy",
      "550": "No response after call",
      "590": "Controller info",
      "592": "Lift plugin",
    },
    sensorLabelsShort: {
      "10": "Sensecloud OK",
      "23": "Mobile signal",
      "54": "Energy meter 3-phase",
      "55": "Energy meter 1-phase",
      "104": "Visit",
      "105": "Available",
      "106": "Elevator fault",
      "210": "Aggregated fault",
      "211": "Aggregated message",
      "212": "Technical avail.",
      "500": "Elevator status",
      "501": "Current stop",
      "502": "Front door",
      "503": "Rear door",
      "513": "Status messages",
      "514": "Last passed",
      "515": "Current stop",
      "524": "Controller OK",
      "550": "No response",
      "590": "Controller info",
      "592": "Lift plugin",
    },
    sensorValues: {
      C: "Closed",
      D: "Moving down",
      I: "Inactive",
      O: "Open",
      U: "Moving up",
      X: "Locked",
      "-": "Closing",
      "+": "Opening",
      "?": "Error",
      "¿": "Error",
    },
  },
} as const;

export type SupportedLocale = keyof typeof translations;
export type UiMessageKey = keyof (typeof translations)["nl"]["ui"];
export type ErrorMessageKey = keyof (typeof translations)["nl"]["errors"];
